import React, { useEffect, useMemo, useState } from "react";
import { StorageConstants } from "../../storage/storageConstants";
import { getOAuthData } from "../../network/getOAuthData";

const OAuth = ({ component, altSrc = "" }) => {
  const [finalUri, setFinalUri] = useState(undefined);
  const mediaUrl = component?.props?.src;

  useEffect(() => {
    const getAuthUri = async () => {
      if (!mediaUrl) {
        setFinalUri(altSrc || undefined);
        return;
      }
      const data = await getOAuthData(mediaUrl);
      if (data) setFinalUri(data);
      else setFinalUri(altSrc);
    };
    getAuthUri();
  }, [mediaUrl]);

  if (!component || !React.isValidElement(component)) {
    console.info("Passed component is not valid component.");
    return component;
  }

  // Modify the value of Authorization header if props exist
  const modifiedProps = { ...component.props };
  modifiedProps.src = finalUri;
  modifiedProps.url = finalUri;
  const AUTH_SAFE_COMP = React.cloneElement(component, modifiedProps);

  return <React.Fragment key={finalUri}>{AUTH_SAFE_COMP}</React.Fragment>;
};

export default OAuth;
